import { render, staticRenderFns } from "./CustomBar.vue?vue&type=template&id=0595093d&scoped=true"
import script from "./CustomBar.vue?vue&type=script&lang=js"
export * from "./CustomBar.vue?vue&type=script&lang=js"
import style0 from "./CustomBar.vue?vue&type=style&index=0&id=0595093d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0595093d",
  null
  
)

export default component.exports